module.exports = __webpack_public_path__ + "media/community_center.fb5ad449.jpg";